import FetchClient, { type ApiResponse } from "./FetchClient";

export interface UserPushTestProduct {
  upc: string;
  storeId: string;
  productName: string;
  productUrl: string;
  imageUrl: string;
  price: number;
  msrp: number;
  discountPercent: number;
}

export interface UserPushTestPreview {
  products: UserPushTestProduct[];
  platforms: string[];
}

export async function getUserPushTestPreview(userId: string, storeId: string): Promise<UserPushTestPreview> {
  const params = new URLSearchParams({ storeId });
  const response = await FetchClient.get<ApiResponse<UserPushTestPreview>>(
    `/admin/users/${encodeURIComponent(userId)}/push-test?${params}`,
  );
  return response.data;
}

export async function sendUserPushTest(userId: string, product: Pick<UserPushTestProduct, "storeId" | "upc">): Promise<{ message: string }> {
  const response = await FetchClient.post<ApiResponse<{ message: string }>>(
    `/admin/users/${encodeURIComponent(userId)}/push-test`,
    { storeId: product.storeId, upc: product.upc },
  );
  return response.data;
}
